import React from "react";
import {NavLink} from 'react-router-dom';
import api from '../../api/Api'
import withStyles from "@material-ui/core/styles/withStyles";
import ReactTable from "react-table";
import "react-table/react-table.css";
import Grid from "@material-ui/core/Grid";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import Business from "@material-ui/icons/Business";
import Tooltip from "@material-ui/core/Tooltip";
import {cardTitle} from "assets/jss/material-dashboard-pro-react.jsx";
import Loader from '../../components/Loader'
import {mappingUI, dashboardRouter} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import {bindActionCreators} from "redux";
import {serverError} from "../../redux/global";
import {connect} from "react-redux";

class ClinicMaster extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            open: true,
            element: "",
            api_url: "",
            api_status: "",
            read: false,
            alert: null,
            clickedId: "",
            redirect: false,
            redirectOne: false,
            redirectAdd: false,
            selectedClinicmasterId: ""
        };
    }

    componentDidMount() {
        this.CallReadApi();

    }

    render() {
        const {classes} = this.props;
        const {data} = this.state;
        if (this.state.data)
            return (
                <div>
                    {this.state.alert}
                    <Grid container>
                        {mappingUI(Permissions.AddMaster) ? <GridItem xs={12} sm={12} md={2}>
                            <NavLink to={dashboardRouter("/clinicmaster/add")}>
                                <Button block color="warning">
                                    <Icon>add</Icon>
                                    <span style={{paddingLeft: 10}}>ADD NEW</span>
                                </Button>
                            </NavLink>
                            <br/>
                        </GridItem> : null}
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" icon>
                                    <CardIcon color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <Business/>
                                            </GridItem>
                                            <GridItem style={{marginTop: -2}}>
                                                <h4>Clinic Masters</h4>
                                            </GridItem>
                                        </GridContainer>
                                    </CardIcon>
                                </CardHeader>
                                <CardBody>
                                    <ReactTable
                                        data={data}
                                        filterable
                                        defaultFilterMethod={(filter, row) =>
                                            String(row[filter.id]) === filter.value}
                                        columns={[
                                            {
                                                columns: [
                                                    {
                                                        Header: "Name",
                                                        accessor: "clinicmaster_name",
                                                        Cell: ({index}) =>
                                                            (<div>
                                                                    <NavLink
                                                                        to={`/clinicmaster/oneClinicMaster/${data[index].clinicmaster_id}`}> {data[index].clinicmaster_name}</NavLink>
                                                                </div>
                                                            ),
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["clinicmaster_name"]}),
                                                        filterAll: true
                                                    },
                                                    {
                                                        Header: "Company Number",
                                                        id: "clinicmaster_companynumber",
                                                        accessor: "clinicmaster_companynumber",
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["clinicmaster_companynumber"]}),
                                                        filterAll: true
                                                    },
                                                    {
                                                        Header: "Admin Name",
                                                        accessor: "clinicmaster_adminname",
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["clinicmaster_adminname"]}),
                                                        filterAll: true
                                                    },
                                                    {
                                                        Header: "Contact",
                                                        accessor: "clinicmaster_contactinfo",
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["clinicmaster_contactinfo"]}),
                                                        filterAll: true
                                                    },
                                                    {
                                                        Header: "Actions",
                                                        id: 'request_state',
                                                        filterable: false,
                                                        sortable: false,
                                                        Cell: ({index}) =>
                                                            (<div style={{justifyContent: "center"}}>
                                                                {mappingUI(Permissions.ViewMaster) ? <NavLink
                                                                    to={dashboardRouter(`/clinicmaster/oneClinicMaster/${data[index].clinicmaster_id}`)}>
                                                                    <Tooltip
                                                                        id="tooltip-top"
                                                                        title="View"
                                                                        placement="bottom"
                                                                        classes={{tooltip: classes.tooltip}}>
                                                                        <Button
                                                                            type="button" color="info"
                                                                            style={{padding: 8, marginLeft: '10%'}}>
                                                                            <Icon style={{fontSize: 20}}>info</Icon>
                                                                        </Button>
                                                                    </Tooltip>
                                                                </NavLink> : null}
                                                                {mappingUI(Permissions.UpdateMaster) ? <NavLink
                                                                    to={dashboardRouter(`/clinicmaster/updateClinicMaster/${data[index].clinicmaster_id}`)}>
                                                                    <Tooltip
                                                                        id="tooltip-top"
                                                                        title="Edit"
                                                                        placement="bottom"
                                                                        classes={{tooltip: classes.tooltip}}>
                                                                        <Button
                                                                            type="button" color="success"
                                                                            style={{padding: 8, marginLeft: '5%'}}>
                                                                            <Icon style={{fontSize: 20}}>edit</Icon>
                                                                        </Button>
                                                                    </Tooltip>
                                                                </NavLink> : null}
                                                                {mappingUI(Permissions.DeleteMaster) ?
                                                                    <Tooltip
                                                                        id="tooltip-top"
                                                                        title="Remove"
                                                                        placement="bottom"
                                                                        classes={{tooltip: classes.tooltip}}>
                                                                        <Button type="button" color="danger"
                                                                                style={{padding: 8, marginLeft: '5%'}}
                                                                                onClick={() => this.CreateAlert(data[index].clinicmaster_id)}>
                                                                            <Icon style={{fontSize: 20}}>close</Icon>
                                                                        </Button>
                                                                    </Tooltip> : null}
                                                            </div>)
                                                    }
                                                ]
                                            }
                                        ]}
                                        defaultPageSize={10}
                                        className="-striped -highlight"
                                    />
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

    CallReadApi = () => {
        api.listClinicMaster().then(({data}) => {
            this.setState({data: data.data})
        }).catch(error => {
            this.props.serverError(true);
        });
    };

    successDelete() {
        this.setState({
            alert: (
                <SweetAlert
                    success
                    style={{display: "block", marginTop: "-100px"}}
                    title="Deleted!"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.success
                    }
                >
                </SweetAlert>
            )
        });
    }

    deleteRecord(id) {
        var postBody = {"clinic_master_id": id};
        api.deleteClinicMaster(postBody)
            .then(json => {
            });

    }

    hideAlert() {
        this.setState({
            alert: null
        });
        window.location.reload()

    }

    CreateAlert(id) {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{display: "block", marginTop: "-100px"}}
                    title="Are you sure?"
                    onConfirm={() => {
                        this.successDelete();
                        this.deleteRecord(id)
                    }}
                    onCancel={() => this.hideAlert()}
                    confirmBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.success
                    }
                    cancelBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.danger
                    }
                    confirmBtnText="Yes, delete it!"
                    cancelBtnText="Cancel"
                    showCancel
                >
                    You will not be able to recover this master!
                </SweetAlert>
            )
        });
    }
}


const mapStateToProps = ({global}) => ({
    searchPrescription: global.searchPrescription,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    serverError
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(sweetAlertStyle)(ClinicMaster));



// WEBPACK FOOTER //
// ./src/views/ClinicMasters/ClinicMasters.jsx